const RESOURCE_LOADER = require('resource-loader');

const Cfg   = require('./config');
const Utill = require('./utillity/utill');
const Calc  = require('./utillity/calculate');

const Home  = require('./animation/home');
const Slider = require('./animation/slider');
const Secscr = require('./animation/section_scroll');

const Header = require("./dom/header");

const _t    = require('./loader');

/*
	npm リポジトリからリソースローダー読み込み。
	読み込み中関数・読み込み完了関数を定義
*/
module.exports.Init = function() {

	_t.InitBg();
	// Home.InitMvDeco();

	const Loader  = new RESOURCE_LOADER();

	for (var i = 0; i < Cfg.RESOURCES.length; i++) {
		Loader.add( Cfg.RESOURCES[i] );
	}

	Loader.onProgress.add(function(e,t){
		_t.RenderText( e.progress );
		_t.RenderBar( e.progress );
	});

	Loader.load((loader, resources) => {
		setTimeout(_t.AnimBreak, 600);
	});
};

/*
	テキスト。
	100まで3桁になるようにして出力
	1刻みではない
*/
module.exports.RenderText = function(progress) {
	let current_text = $('#loader__txt').text();
	let _p = progress > 98? 100: progress;

	for (var i = Number(current_text); i <= _p; i++) {
		
		$('#loader__txt').text( Utill.PaddingZero(i, 3) );

	}



};

/*
 bar 表示
*/
module.exports.RenderBar = function(progress) {
	// var progress = progress<95? progress/5: progress;	// いい感じに調整
	let v = 90 - (90 * Math.round(progress) / 100);
	TweenMax.to( $('#loader__bar'), Calc.ToSecond(450), {
		rotationY: v,
		ease: Expo.easeIn
	});
};


module.exports.InitBg = function() {


	// ふたつ
	$('#loader__bg01, #loader__bg02').each(function(index, el) {
		$(el).css({
			'width': ( Calc.GetWidthByHeight( $(window).height() ) + $(window).width() ) / 2 + 300,
		});
	});

	// loader自体
	$('#loader').css({'background': 'none'})
};


module.exports.AnimBreak = function() {
	let tl01 = new TimelineMax();
	let bar  = $('#loader__bar');

	$('#loader__txt').fadeOut(100);
	$('#loader__msg').fadeOut(100);
	Secscr.SecFadeInit();


	tl01
		.to( bar, Calc.ToSecond(150), {
			height: 2,
			ease: Expo.easeIn,
		}).to(bar, Calc.ToSecond(450), {
			delay: Calc.ToSecond(600),
			rotationZ: 120,
			ease: Expo.easeOut,
		}, 0).to(bar, Calc.ToSecond(450), {
			width: Calc.GetGypotenuse('height', $(window).height()),
			ease: Power2.easeOut,
			delay: Calc.ToSecond(500),
			onComplete: Break,
		}, '-=1');

	function Break() {
		$('#loader__bar').hide();
		$('#loader__bg01, #loader__bg02').each(function(index, el) {
			let d = index===0? -1: 1;
			TweenMax.to($(el), Calc.ToSecond(690), {
				x: $(el).width() * d,
				ease: Expo.easeOut,
				onComplete: StartTopPage,
			});
		});
	}
	function StartTopPage() {
		$('#loader').hide();
		Slider.Start();
		setTimeout(Secscr.SecFadeIn(0, 1), 600);
		//setTimeout(Home.AfterChangeDeco, 3000);
		setTimeout(Header.FadeIn, 1200);
	}
};




// WEBPACK FOOTER //
// ./html/_src/js_wb/loader.js